import React, { useState, useCallback, useEffect } from "react";
import ReferenceItem from "../../steps/Reference/ReferenceItem";
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../redux/system/actions';
import ConfirmModal from "../../../common/modals/ConfirmModal";
import ReferenceForm from "../../steps/Reference/ReferenceForm"

const CONFIRM_MODAL_ID = 'confirmModal';

function ReferenceMainMenu({ curriculumVitae, handleSaveItem, handleDeleteItem, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [references, setReferences] = useState(curriculumVitae.curriculumVitaeReferences || []);
    const [referenceToDelete, setReferenceToDelete] = useState(null);
    const [editingReference, setEditingReference] = useState(null);
    const [addingReference, setAddingReference] = useState(false);

    useEffect(() => {
        setReferences(curriculumVitae.curriculumVitaeReferences || []);
    }, [curriculumVitae.curriculumVitaeReferences]);

    const confirmDeleteReference = async (ReferenceId) => {
        setReferenceToDelete(ReferenceId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    const handleSave = async (itemData, type) => {
        setAddingReference(false);
        handleSaveItem(itemData, type);
    }

    return (
        <div className="cv-main-menu-overview">
            {(editingReference || addingReference) ? (
                <>
                    <h3 className="cv-main-menu-edit-mode">
                        {editingReference ? 'Edit Mode' : 'Add Reference'}
                    </h3>
                    <div className="main-menu-form-wrapper">
                    <ReferenceForm
                        curriculumVitaeId={curriculumVitae.id}
                        initialReference={editingReference}
                        setEditingReference={setEditingReference}
                        setAddingReference={setAddingReference}
                        onSave={(ReferenceData) => handleSave(ReferenceData, 'curriculumVitaeReferences')}
                        status={status}
                        />
                    </div>
                </>
            ) : (
                <>
                <div className="cv-main-menu-list">
                    <ul>
                        {curriculumVitae.curriculumVitaeReferences
                            .slice()
                            .sort((a, b) => {
                                const dateA = a.currentJob ? new Date() : new Date(a.endDate);
                                const dateB = b.currentJob ? new Date() : new Date(b.endDate);
                                
                                return dateB - dateA;
                            })
                            .map((reference) => (
                                <div key={reference.id} className="main-menu-item-wrapper">
                                    <ReferenceItem
                                        reference={reference}
                                        onEdit={() => setEditingReference(reference)}
                                        onDelete={() => confirmDeleteReference(reference.id)}
                                    />
                                </div>
                            ))}
                    </ul>
                </div>
                    <button className="cv-main-menu-add" onClick={() => setAddingReference(true)}>
                        <i className="pe-7s-plus mr-2"></i>
                        Add another reference
                    </button>
                </>
            )}

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this reference?"
                message="This will permanently remove the selected reference from your profile. Do you wish to proceed?"
                onConfirm={() => handleDeleteItem(referenceToDelete, 'curriculumVitaeReferences')}
            />
        </div>
    );
}

export default ReferenceMainMenu;
